import { typography } from '@everlywell/leaves';
import React from 'react';
import styled from 'styled-components';

import StyledLink from '../../styles/StyledLink';

const List = styled.ul`
  width: 100%;
  margin-top: 40px;
  margin-bottom: 8px;
  max-width: 650px;
`;

const Subcategory = styled.li`
  display: inline-block;
  margin: 0 0.25em 0.25em 0;
`;

const SubcategoryLink = styled(StyledLink)`
  font-weight: ${typography.weight.bold};
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.7px;
`;

const SubcategoryList = (props) => (
    <List>
      {props.subcategories.map((subcategory, i) => (
        <Subcategory key={subcategory.id}>
          <SubcategoryLink to={`/categories/${subcategory.slug}/`}>
            {i < props.subcategories.length - 1
              ? `${subcategory.title},`
              : `${subcategory.title}`}
          </SubcategoryLink>
        </Subcategory>
      ))}
    </List>
  );

export default SubcategoryList;
